<template>
  <Modal v-model="show" width="700" :title="title" :mask-closable="false">
    <div slot="footer">
      <Button @click="show = false">取消</Button>
      <Button type="primary" :loading="btn_loading" @click="saveForm">确认</Button>
    </div>
    <Form
      ref="Form"
      label-position="right"
      :rules="ruleValidate"
      :model="editListForm"
      :label-width="120"
    >
      <FormItem label="服务商名称" prop="name">
        <Input placeholder="请输入服务商名称" v-model="editListForm.name"></Input>
      </FormItem>

      <FormItem label="使用情况" prop="is_usage">
        <Select
          clearable
          filterable
          class="search-input"
          placeholder="请选择使用情况"
          v-model="editListForm.is_usage"
        >
          <Option :value="1">在用</Option>
          <Option :value="0">停用</Option>
        </Select>
      </FormItem>
      <FormItem label="是否愿意付费" prop="is_renew">
        <RadioGroup v-model="editListForm.is_renew">
          <Radio :label="1">是</Radio>
          <Radio :label="0">否</Radio>
          <Radio :label="2">待定</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="是否愿意推荐单小二" prop="is_recommend">
        <RadioGroup v-model="editListForm.is_recommend">
          <Radio :label="1">是</Radio>
          <Radio :label="0">否</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="回访等级" prop="return_level">
        <Select
          clearable
          filterable
          class="search-input"
          placeholder="请选择使用情况"
          v-model="editListForm.return_level"
        >
          <Option
            v-for="(item, index) in return_level_list"
            :key="index"
            :value="item.id"
          >{{item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem label="回访情况" prop="return_visit">
        <Input type="textarea" :rows="4" placeholder="请输入回访情况" v-model="editListForm.return_visit" />
      </FormItem>
      <FormItem label="企业情况介绍：" prop="company_profile">
        <Input
          type="textarea"
          :rows="4"
          placeholder="请输入企业情况介绍"
          v-model="editListForm.company_profile"
        />
      </FormItem>
    </Form>
  </Modal>
</template>
<script>
import AddressSelect from '@/components/AddressSelect'
import { mapState } from 'vuex'
export default {
  name: 'AddModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object
    }
  },
  components: {
    AddressSelect
  },
  watch: {
    value(v) {
      this.show = v
      this.editListForm = this.form
    },
    show(v) {
      this.$emit('input', v)
    }
  },
  computed: {
    ...mapState('global', ['serviceSize', 'serviceLevel']),
    title() {
      return '更新用户信息'
    }
  },
  data() {
    return {
      btn_loading: false,
      show: false,
      ruleValidate: {
        name: [
          {
            required: true,
            message: '服务商名称不能为空',
            trigger: 'blur'
          }
        ]
      },
      return_level_list: [
        { id: 1, name: 'A' },
        { id: 2, name: 'B' },
        { id: 3, name: 'C' },
        { id: 4, name: 'D' },
        { id: 5, name: 'E' }
      ],
      editListForm: {}
    }
  },

  methods: {
    saveForm() {
      this.$refs.Form.validate(valid => {
        if (valid) {
          this.btn_loading = true
          const method = 'post'
          this.$http
            .request({
              method,
              url: '/enterprise/analyze',
              data: this.editListForm
            })
            .then(res => {
              if (res.success) {
                this.$Message.success('保存成功')
                this.show = false
                this.$emit('callback')
              } else {
                this.$Message.success(res.message || '保存失败')
              }
              this.btn_loading = false
            })
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/EnterpriseAnalyzeList/Modal/AddModal.vue